import { css } from '@emotion/react';

export const noMarginTop = css`
  margin-top: 0 !important;
`;
